import React from 'react'
import axios from 'axios';
import { Breadcrumbs } from "@material-tailwind/react";
import {Link, useNavigate} from 'react-router-dom'
import { MdOutlineAddPhotoAlternate } from "react-icons/md";
import { BiHotel } from "react-icons/bi";
import { MdOutlineHomeWork, MdOutlinePayment } from "react-icons/md";
import { IoBedOutline } from "react-icons/io5";
import { RxDimensions } from "react-icons/rx";
import { CiCalendarDate } from "react-icons/ci";
import { MdOutlinePool, MdElevator } from "react-icons/md";
import { MdOutlineWifi, MdBalcony } from "react-icons/md";
import { RiParkingBoxFill } from "react-icons/ri";
import { SlScreenDesktop } from "react-icons/sl";
import { IoRestaurant } from "react-icons/io5";
import { LuMicrowave, LuArmchair } from "react-icons/lu";
import { GiBathtub } from "react-icons/gi";
import { FaCity, FaKitchenSet } from "react-icons/fa6";
import { FaUser, FaBellConcierge } from "react-icons/fa6";
import { GiMoneyStack, GiCctvCamera } from "react-icons/gi";
import { MdOutlineRoomPreferences, MdOutlineSevereCold } from "react-icons/md";
import { AiOutlineEdit } from "react-icons/ai";
import { useState, useEffect } from 'react';
import Loading from '../../../COMPONENTS/Loading/Loading'
import { GoArrowLeft } from "react-icons/go";
import SidebarTop from '../../SidebarTop';
import { TbFridge } from "react-icons/tb";
import Heber from "../../../../API/tourisme/hebergement/index"
import { ToastContainer, toast } from "react-toastify"
import { IoMdPin, IoIosMail } from "react-icons/io";
import { FaPhoneAlt } from 'react-icons/fa';
import { Modal, Button, Form } from 'react-bootstrap';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { loadStripe } from '@stripe/stripe-js';
import { getPaymentStatus } from '../../../../API/stripe/StripeTranction';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import Create from '../../../../Payment/Create';


const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));


// Clé publique Stripe
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);




function AjoutHebergement() {

    localStorage.setItem('url', JSON.stringify('/Dashboard/Publications/Hebergement/Ajouter_des_hebergements'));

    const [data, setData] = useState(() => {
        const saved = localStorage.getItem("data");
        const initialValue = saved !== null ? JSON.parse(saved) : null;
        return initialValue;
    });
    //const data = localStorage.getItem("data")
   

    useEffect(() => {
        if (data === null) {
            navigate("/Connexion");
            return;
        }

                axios
                .get(`${process.env.REACT_APP_BASE_URL}/api/get/info/website`)
                .then((res) => {
                if (res.data.status === 200 ) {
                    setCurr(res.data.currency);
                    localStorage.setItem('id_currency', res.data.currency.id_currency);
                } else {
                    console.warn("Réponse inattendue de l'API :", res.data);
                }
                })
                .catch((err) => {
                console.error("Erreur lors de l'appel à l'API :", err);
                });

        getPriceDollar();
        getPricePub();

        //country
        axios.get(`${process.env.REACT_APP_BASE_URL}/api/country/list`)
     .then(response => {setCountries(response.data.data)})
     //.then(response => console.log(response.data.data))
     .catch(err => console.log(err))

     const sessionId = localStorage.getItem('sessionId');
    if(sessionId){
        getPaymentStatus(sessionId).then(response => {
            //console.log(response.data)
            if (response.data.status === 'succeeded') {
                handlePopupStripeSuccess();
                
            }
            }).catch(error => {
                console.error('Erreur lors de la récupération du statut de paiement:', error);
        });
    }
    localStorage.removeItem('sessionId');
     
        const timer = setTimeout(() => {
            // Après 5 secondes, masquer le spinner et rediriger l'utilisateur
            setLoading(false);
        }, 2000); // 5000 millisecondes = 5 secondes

        // Nettoyer le timer si le composant est démonté avant la fin du délai
        return () => clearTimeout(timer);
    }, []);

    const [cities, setCities] = useState([]);
    const [countries, setCountries] = useState([]);
    const [provinces, setProvinces] = useState([]);
    const [address, setAddress] = useState([]);
    const [pricePub, setPricePub] = useState(null);
    const [priceD, setPriceD] = useState(null);
    const [open,setOpen] = useState(false);
    const [options, setOptions] = useState(null);
    const [curr,setCurr] = useState();
    
    const [loading, setLoading] = useState(true);
    
    //const [montantTotal, setMontantTotal] = useState(0);
    const [formData, setFormData] = useState(
        JSON.parse(localStorage.getItem('formData')) || {}
    );
    
    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setFormData({ ...formData, [name]: value });

         // Enregistrez l'état du formulaire dans le stockage local
        localStorage.setItem('formData', JSON.stringify(
            {...formData,[event.target.name]: event.target.value,}
        ));
  
    };

   
    
    //console.log(data)
    const handleCountryChange = (selectedOption) => {
       
        localStorage.setItem('code', selectedOption.value);  
        
        setFormData({ ...formData, country: selectedOption.value });  
        axios.get(`${process.env.REACT_APP_BASE_URL}/api/province/list/${selectedOption.value}`)
            .then(response => {
                console.log(response.data.data)
                setProvinces(response.data.data)
            })
            .catch(err => console.log(err));
    };
    

    const handleProvinceChange = (selectedProvince) => {
       // console.log(selectedProvince)
        //const { value } = selectedProvince.value;
        localStorage.setItem('province',selectedProvince.value)
        setFormData({ ...formData, province: selectedProvince.value });
        console.log(selectedProvince.value)
    
        // city
        axios.get(`${process.env.REACT_APP_BASE_URL}/api/city/list/${selectedProvince.value}`)
            .then(response => {
                console.log(response.data.data)
                setCities(response.data.data);
            })
            .catch(err => console.log(err));
    };

    const handleCityChange = (selectedCity)=>{
         localStorage.setItem('ville',selectedCity.value)
         setFormData({ ...formData, ville: selectedCity.value });
    }


    // États pour gérer le formulaire et le popup
    const [showPopup, setShowPopup] = useState(false);
    
    //Récuppérer le prix de publication
    const getPricePub = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_BASE_URL}/api/prix/pub/hebergement`);
        //console.log("Le prix provenant de la base est "+ res.data.data.Prices);
        setPricePub(res.data.data.Prices);
        localStorage.setItem('pricePub', res.data.data.Prices);
      
    } catch (err) {
        console.log(err);
      }
    };

    const getPriceDollar = async () => {
        try {
          const res = await axios.get(`${process.env.REACT_APP_BASE_URL}/api/prix/dollar`);
          console.log(res.data);
          setPriceD(res.data.data.value_to_xof);
        } catch (err) {
          console.log(err);
        }
      };
      
    const navigate = useNavigate();
    const [errors,setErrors] =useState({});
    let fd = new FormData();


    useEffect(()=>{
        if(data?.azId !== null)
        {
              //adresse
            axios.get(`${process.env.REACT_APP_BASE_URL}/api/utilisateur/adresse/${data?.azId}`)
            .then(response => {
            setAddress(response.data.data)
                })
            .catch(err => console.log(err))
        }else{
            navigate("/Connexion")
            return;
        }
       
    },[data?.azId])

     useEffect(() => {
            if (address && address.Adresses) {
              fd.append("adresse",address.Adresses)      
            }
        }, [address]);

     let totalPaid = (parseFloat(pricePub) * Math.ceil((new Date(formData.date_fin) - new Date(formData.date_debut))/ (1000 * 60 * 60 * 24)))
     if(totalPaid > 0)
    {
        localStorage.setItem('montant',totalPaid)
    }
    const verifyValidateForm = ()=>{
       // console.log(formData.lieu)
        fd.append("nom", formData.name_h ? formData.name_h  : "" );
        fd.append("user", data.userId);
        fd.append("type", formData.type ? formData.type : "");
        fd.append("methode", formData.methode ? formData.methode : "");
        fd.append("date", formData.date ? formData.date : "");
        fd.append("adresse", formData.lieu ? formData.lieu : address.Adresses);
        fd.append("size", formData.perimetre ? formData.perimetre : "");
        fd.append("lit", formData.bed_type ? formData.bed_type : "");
        fd.append("ascenseur", formData.ascenseur ? formData.ascenseur : "");
        fd.append("balcon", formData.balcon ? formData.balcon : "");
        fd.append("concierge", formData.concierge ? formData.concierge : "");
        fd.append("camera", formData.camera ? formData.camera : "");
        fd.append("clim", formData.climatiseur ? formData.climatiseur : "");
        fd.append("meuble", formData.meuble ? formData.meuble : "");
        fd.append("desc", formData.msg ? formData.msg : "");
        fd.append("chambre", formData.nbre ? formData.nbre : "");
        fd.append("note", formData.note ? formData.note : "");
        fd.append("parking", formData.parking ? formData.parking : "");
        fd.append("piscine", formData.piscine ? formData.piscine : "");
        fd.append("prix", formData.prix ? formData.prix : "");
        fd.append("wifi", formData.wifi ? formData.wifi : "");
        fd.append("date_debut", formData.date_debut ? formData.date_debut : "");
        fd.append("date_fin", formData.date_fin ? formData.date_fin : "");
        fd.append("mail", formData.mail ? formData.mail : data.userMail);
        fd.append("tel", formData.phone ? formData.phone : data.userTel);
        fd.append("pays", formData.country ? formData.country : "");
        fd.append("ville", formData.ville ? formData.ville : "");
        fd.append("province", formData.province ? formData.province : "");
        for (let i = 0; i < document.getElementById("photo")?.files.length; i++) {
            fd.append("photo[]", document.getElementById("photo")?.files[i]);
        }

        Heber.verifyForm(fd).then((res)=>{
           // console.log(res.data.status)
             if(res.data.status === 422){
                setErrors(res.data.errors)
                setOpen(false)
             }else{
                if(totalPaid === 0)
                {
                    submitForm();
                    navigate("/Dashboard/Publications/Hebergement/Voir_des_hebergements")
                   
                    return;
                }
                setOpen(true)
             }
        }).catch((err)=>{
                console.log("Erreur lors de l'appel a l'API ",err)
        }).finally(()=>{
            setLoading(false)
        })

        
    }
    const submitForm = (provider,paymentId,currencyId) => {
        //e.preventDefault();
        const pricePubFromStorage = localStorage.getItem('pricePub');
        // console.log('PricePub from localStorage:', pricePubFromStorage);
        fd.append("nom", formData.name_h ? formData.name_h  : "" );
        fd.append("user", data.userId);
        fd.append("type", formData.type ? formData.type : "");
        fd.append("methode", formData.methode ? formData.methode : "");
        fd.append("date", formData.date ? formData.date : "");
        fd.append("adresse", formData.lieu ? formData.lieu : address.Adresses);
        fd.append("size", formData.perimetre ? formData.perimetre : "");
        fd.append("lit", formData.bed_type ? formData.bed_type : "");
        fd.append("ascenseur", formData.ascenseur ? formData.ascenseur : "");
        fd.append("balcon", formData.balcon ? formData.balcon : "");
        fd.append("concierge", formData.concierge ? formData.concierge : "");
        fd.append("camera", formData.camera ? formData.camera : "");
        fd.append("clim", formData.climatiseur ? formData.climatiseur : "");
        fd.append("meuble", formData.meuble ? formData.meuble : "");
        fd.append("desc", formData.msg ? formData.msg : "");
        fd.append("chambre", formData.nbre ? formData.nbre : "");
        fd.append("note", formData.note ? formData.note : "");
        fd.append("parking", formData.parking ? formData.parking : "");
        fd.append("piscine", formData.piscine ? formData.piscine : "");
        fd.append("prix", formData.prix ? formData.prix : "");
        fd.append("wifi", formData.wifi ? formData.wifi : "");
        fd.append("date_debut", formData.date_debut ? formData.date_debut : "");
        fd.append("date_fin", formData.date_fin ? formData.date_fin : "");
        fd.append("mail", formData.mail ? formData.mail : data.userMail);
        fd.append("tel", formData.phone ? formData.phone : data.userTel);
        fd.append("pays", formData.country ? formData.country : "");
        fd.append("ville", formData.ville ? formData.ville : "");
        fd.append("province", formData.province ? formData.province : "");
        for (let i = 0; i < document.getElementById("photo")?.files.length; i++) {
            fd.append("photo[]", document.getElementById("photo")?.files[i]);
        }
        if (formData.date_debut && pricePubFromStorage && formData.date_fin) {
            const days = Math.ceil((new Date(formData.date_fin) - new Date(formData.date_debut)) / (1000 * 60 * 60 * 24));
            const montant = parseFloat(pricePubFromStorage) * days;
            fd.append("montant", montant);
            console.log('Calculated montant:', montant);

         }
        else {
            toast.error("Veuillez remplir tous les champs");
            return;
        }
        for (let i = 0; i < document.getElementById("photo")?.files.length; i++) {
            fd.append("photo[]", document.getElementById("photo")?.files[i]);
        }
        
        setLoading(true);
        Heber.submitForm(fd)
            .then((res) => {
                //console.log(res);
                if (res.data.status === 201) {
                     if(provider !== null && paymentId !== null && currencyId !== null ){
                            const formD = {
                                    userId:data.azId,
                                    montant:totalPaid,
                                    provider: provider,
                                    payement_id:paymentId ,
                                    currency:currencyId,
                                    annonce_number: res.data.announce_number,
                                    description:"Transaction d'ajout d'un hebergement"
                                }
                            axios.post(`${process.env.REACT_APP_BASE_URL}/api/store/rechargement-paiememnt`,formD)
                                .then((res)=>{
                                if(res.data.status === 200){
                                //toast.success(res.data.message);
                                //console.log("enregistrement reussie")
                                }
                                }).catch((err)=>{
                                console.log("Erreur lors de l'appel a l'API ",err)
                                })
                    }
                    //toast.success(res.data.message);
                    localStorage.removeItem('formData');
                    localStorage.removeItem('pricePub');
                    localStorage.removeItem('province');
                    localStorage.removeItem('ville')
                    localStorage.setItem('message',res.data.message)
                    localStorage.setItem('idannonce',res.data.announce_number)
                    navigate("/Dashboard/Publications/Hebergement/Voir_des_hebergements")
                    setErrors({})
                    
                    //console.log(res);
                } else {
                    toast.error(res.data.message);
                    //console.log(res);
                }
            })
            .catch((err) => {
                //toast.error('Erreur merci de reessayer !');
                console.log(err);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    // Fonction de gestion de la soumission du formulaire
    const handleSubmit = (event) => {
        event.preventDefault();
        verifyValidateForm();
        // Afficher le popup de paiement
        //setShowPopup(true);
    };

    // Callback de succès du popup de paiement
    const handlePopupSuccess = () => {
        setShowPopup(false);
        submitForm();
    };

    // Callback d'annulation du popup de paiement
    const handlePopupCancel = () => {
        setShowPopup(false);
    };

    const handlePopupStripeSuccess = () => {
        submitForm();
        localStorage.removeItem('formData');
        localStorage.removeItem('pricePub');
    };


    let savedCode = localStorage.getItem('code') ? localStorage.getItem('code') : localStorage.getItem('is_code');
    let savedProvince = localStorage.getItem('province')
    let savedVille =localStorage.getItem('ville');

    useEffect(() => {
            if (curr) {
        
            setOptions({
                id_currency: curr.id_currency,
                success_url: window.location.origin ,
                cancel_url: window.location.href,
                amount:totalPaid,
                customer: {
                id: data.azId,
                first_name: data.userLastname ?? '',
                last_name: data.userName ?? '',
                email: data.userMail,
                phone: data.userTel,
                code_country: 'BJ'
                },
                seller_number: 1
            });
            }
    }, [curr,totalPaid]);
    
     useEffect(() => {
        if (savedCode) {
           // setCode(savedCode);
           setFormData({
            ...formData,
            country: savedCode,
            province: savedProvince,
            ville: savedVille,
            wifi: '1',
            piscine:'1',
            camera:'1',
            balcon:'1',
            ascenseur:'1',
            concierge:'1',
            parking: '1',
            climatiseur: '1',
            meuble:'1'
        });
            axios.get(`${process.env.REACT_APP_BASE_URL}/api/province/list/${savedCode}`)
            .then(response => {
                setProvinces(response.data.data)
                })
            .catch(err => console.log(err))

            axios.get(`${process.env.REACT_APP_BASE_URL}/api/city/list/${savedProvince}`)
            .then(response => {
                setCities(response.data.data);
            })
            .catch(err => console.log(err));
        }
    }, [savedCode]); 

     useEffect(()=>{
              localStorage.removeItem('formData');
      },[])

    const today = new Date().toISOString().split("T")[0];

    const {t} = useTranslation()
    const lang = localStorage.getItem("langague");



  return (
    <div className='flex flex-row bg-[#eeee]'>
          {loading ? (
              // Afficher le spinner tant que loading est true
              <Loading />
          ) : (
              <>
        {/* sidebar left */}

        <div className='w-screen h-screen barre_scroll'>
            {/* navbar top orange */}
             <SidebarTop />
            {/* navbar top gris*/}
            <div className='bg-[#f7f7f7] sm:h-10 s:h-14 mt-[50px]'>
                <Breadcrumbs>
                      <Link to="" className="opacity-60 md:text-base s:text-xs">
                          {t("Mes publications")}
                      </Link>
                      <Link to="/Dashboard/Publications/Hebergement/Voir_des_hebergements" className="opacity-60 md:text-base s:text-xs">
                          {t("Hebergements")}
                      </Link>
                      <Link to="" className='md:text-base s:text-xs'>
                         {t("Ajouter")}
                      </Link>
                </Breadcrumbs>
            </div>

            <div>
                <ToastContainer />
            </div>

            <Link to="/Dashboard/Publications/Hebergement/Voir_des_hebergements">
                <div className='flex flex-row items-center space-x-2 relative top-8 s:left-5 sm:left-12 w-[280px]'>
                    <GoArrowLeft className='text-[#fe7f2d]  text-lg' />
                    <p>{t("Retour à la page précedente")}</p>
                </div>
            </Link>
            {/* container formulaire */}
            <div className='flex justify-center py-20 '>
            <form onSubmit={handleSubmit} className='flex flex-col items-center space-y-3 '>

                <div className='bg-white  s:p-4 xs:p-10 xs:w-full s:w-[260px] sm:w-[340px]  rounded-md border-b-8  shadow flex flex-col space-y-6 '>
                    {/* nom d'apartement */}
                    <div className='flex flex-col space-y-3'>
                        <div className='flex flex-row items-center space-x-2'>
                            <MdOutlineHomeWork className='text-xl text-[#fe7f2d]' />
                            <label>{t("Nom")} <span className='text-red-600'>*</span></label>
                        </div>
                        <input onChange={handleInputChange}  type='text' name='name_h' placeholder='Ex : Villa la joie' className='xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded'/>
                        {errors.nom &&  <p className='text-red-500'>{errors.nom}</p> }
                    </div>
                    {/* Ajout des images */}
                    <div className='flex flex-col space-y-3'>
                        <div className='flex flex-row items-center space-x-2'>
                            <MdOutlineAddPhotoAlternate className='text-xl text-[#fe7f2d]' />
                            <label> {t("Ajouter des images")} <span className='text-red-600'>*</span></label>
                        </div>
                        <input onChange={handleInputChange}  type="file" accept="image/*" multiple id="photo" name="photo" className='xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 '/>
                        {errors.photo &&  <p className='text-red-500'>{errors.photo}</p> }
                    </div>
                    {/* Type de paiement */}
                    <div className='flex flex-col space-y-3'>
                        <div className='flex flex-row items-center space-x-2'>
                            <MdOutlinePayment className='text-xl text-[#fe7f2d]' />
                            <label>{t("Méthode de paiement")} <span className='text-red-600'>*</span></label>
                        </div>
                        <select onChange={handleInputChange} name="methode" className='xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded pl-4'>
                        <option value=""></option>
                        <option value="1">{t("Paiement en ligne et sur place")}</option>
                        <option value="2">{t("Paiement en ligne")}</option>
                        <option value="3">{t("Paiement sur place")}</option>
                        </select>
                        {errors.methode && <p className='text-red-500'> {errors.methode} </p>}
                    </div>
                    {/* Type */}
                    <div className='flex flex-col space-y-3'>
                        <div className='flex flex-row items-center space-x-2'>
                            <MdOutlineHomeWork className='text-xl text-[#fe7f2d]' />
                            <label>Type <span className='text-red-600'>*</span></label>
                        </div>
                        <select onChange={handleInputChange} name="type" className='xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded pl-4'>
                            <option value=""></option>
                            <option value="other">{t("Autre")}</option>
                            <option value="house">{t("Maison")}</option>
                            <option value="hotel">Hotel</option>
                            <option value="appartment">{t("Appartement")}</option>
                        </select>
                        {errors.type && <p  className='text-red-500'>{errors.type}</p>}
                    </div>
                    {/* nombre de la chambre */}
                    <div className='flex flex-col space-y-3'>
                        <div className='flex flex-row items-center space-x-2'>
                            <BiHotel className='text-xl text-[#fe7f2d]' />
                            <label>{t("Nombres de pièces")} <span className='text-red-600'>*</span></label>
                        </div>
                        <input onChange={handleInputChange} type='number' name='nbre' placeholder='Ex : 2 ' className='xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded'/>
                        {errors.chambre && <p className='text-red-500'>{errors.chambre}</p>}
                    </div>
                    {/* perimetre chambre */}
                    <div className='flex flex-col space-y-3'>
                        <div className='flex flex-row items-center space-x-2'>
                            <RxDimensions className='text-xl text-[#fe7f2d]' />
                            <label>{t("Périmetre")}(m²) <span className='text-red-600'>*</span></label>
                        </div>
                        <input onChange={handleInputChange} type='number' name='perimetre' placeholder='Ex : 40 ' className='xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded'/>
                        {errors.size && <p className='text-red-500'>{errors.size}</p>}
                    </div>
                    {/* Type de lit */}
                    <div className='flex flex-col space-y-3'>
                        <div className='flex flex-row items-center space-x-2'>
                            <IoBedOutline className='text-xl text-[#fe7f2d]' />
                            <label>{t("Type de lit")} <span className='text-red-600'>*</span></label>
                        </div>
                        <select onChange={handleInputChange} name="bed_type" className='xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded pl-4'>
                        <option value=""></option>
                        <option value="Lit simple">{t("Lit simple")}</option>
                        <option value="Lit double">{t("Lit double")}</option>
                        <option value="Lit triple">{t("Lit triple")}</option>
                        </select>
                        {errors.lit && <p className='text-red-500'>{errors.lit}</p>}
                    </div>
                     
                </div>

                <div className='bg-white  s:p-4 xs:p-10 xs:w-full s:w-[260px] sm:w-[340px]  rounded-md border-b-8  shadow flex flex-col space-y-6 '>
                    {/* Tel */}
                    <div className='flex flex-col space-y-3'>
                        <div className='flex flex-row items-center space-x-2'>
                            <FaPhoneAlt className=' text-[#fe7f2d]' />
                            <label>{t("Telephone")} <span className='text-red-600'>*</span></label>
                        </div>
                        <input type='tel' defaultValue={data.userTel} name='phone' onChange={handleInputChange} placeholder="Ex : +225 xxx xxx xxxx " className='xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded' />
                        {errors.tel && <p className='text-red-500'>{errors.tel}</p>}
                    </div>
                    {/* Mail */}
                    <div className='flex flex-col space-y-3'>
                        <div className='flex flex-row items-center space-x-2'>
                            <IoIosMail className=' text-[#fe7f2d]' />
                            <label>{t("Adresse e-mail")} <span className='text-red-600'>*</span></label>
                        </div>
                        <input defaultValue={data.userMail} type='email' name='mail' onChange={handleInputChange} placeholder="Ex : info@monbonsejour.com " className='xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded' />
                        {errors.mail && <p className='text-red-500'>{errors.mail}</p>}
                    </div>
                    {/* Country */}
                    <div className='flex flex-col space-y-3'>
                        <div className='flex flex-row items-center space-x-2'>
                            <IoMdPin className=' text-[#fe7f2d]' />
                            <label>{t("Pays")} <span className='text-red-600'>*</span></label>
                        </div>
                        <Form.Group>
                            <Select
                                onChange={handleCountryChange}
                                name="country"
                                value={savedCode ? {
                                    label: lang === 'fr' 
                                        ? countries.find(pay => pay?.code === savedCode)?.fr_Name 
                                        : countries.find(pay => pay?.code === savedCode)?.Name,
                                    value: savedCode
                                } : null} // Inclut la propriété value de manière correcte
                                options={countries.map(pay => ({
                                    label: lang === 'fr' ? pay?.fr_Name : pay?.Name,
                                    value: pay?.code
                                }))}
                                className="xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded pl-4"
                            />
                        </Form.Group>

                         {errors.pays && <p className='text-red-500'>{errors.pays}</p>}
                    </div>
                    {/* Province */}
                    <div className='flex flex-col space-y-3'>
                        <div className='flex flex-row items-center space-x-2'>
                            <IoMdPin className=' text-[#fe7f2d]' />
                            <label>{t("Province")} <span className='text-red-600'>*</span></label>
                        </div>
                         <Form.Group>
                                <Select
                                    onChange={handleProvinceChange}
                                    name="province"  
                                    value={savedProvince ? {
                                             label: lang === 'fr' ? provinces.find(prov => prov?.code_province === savedProvince)?.fr_Name
                                              : provinces.find(prov => prov?.code_province === savedProvince)?.Name,
                                                value: savedProvince
                                            } : null} // Inclut la propriété value
                                    options={provinces.map(prov => ({
                                        label: lang === 'fr' ? prov?.fr_Name : prov?.Name,
                                        value: prov?.code_province
                                    }))}
                                    className="xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded pl-4"
                                />
                          </Form.Group>
                        {/* <Form.Group>
                            <Select
                                onChange={handleProvinceChange}
                                name="province"
                                value={address.code_province ? {label:provinces.find(prov=>prov.code_province === address.code_province),value:address.code_province}: null}
                                options={provinces.map(prov => ({
                                    label: prov?.fr_Name,
                                    value: prov?.code_province
                                }))}
                                className="xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded pl-4"
                                placeholder="Sélectionner une province"
                            />
                        </Form.Group> */}


                        {/* <select onChange={handleProvinceChanges} name='province' className='xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded pl-4'>
                                <option value={address.code_province}>{address.pname}</option>
                                    {provinces.map((option, index) => (
                                        <option key={index} value={option.code_province}>{option.fr_Name}</option>
                                        ))}
                                            
                         </select> */}
                         {errors.province && <p className='text-red-500'>{errors.province}</p>}
                    </div>
                    {/* Ville */}
                    <div className='flex flex-col space-y-3'>
                        <div className='flex flex-row items-center space-x-2'>
                            <IoMdPin className=' text-[#fe7f2d]' />
                            <label>{t("Ville")} <span className='text-red-600'>*</span></label>
                        </div>
                            <Form.Group>
                                    <Select
                                        onChange={handleCityChange}
                                        name="ville"  
                                        value={savedVille ? {
                                               label: lang === 'fr' ? cities.find(city => city?.code_city === savedVille)?.fr_Name
                                               : cities.find(city => city?.code_city === savedVille)?.Name,
                                               value: savedVille}
                                              : null} // Inclut la propriété value
                                        options={cities.map(city => ({
                                            label: city?.fr_Name,
                                            value: city?.code_city
                                        }))}
                                        className="xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded pl-4"
                                    />
                            </Form.Group>
                        {/* <select onChange={handleInputChange}  
                                name='ville' 
                                className='xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded pl-4'>
                               <option value={address.code_city}>{address.cname}</option>
                                {cities.map((option, index) => (
                                    <option key={index} value={option.code_city}>{option.fr_Name}</option>
                                    ))}             
                         </select> */}
                         {errors.ville && <p className='text-red-500'>{errors.ville}</p>}
                    </div>
                    {/* Lieu */}
                    <div className='flex flex-col space-y-3'>
                        <div className='flex flex-row items-center space-x-2'>
                            <IoMdPin className=' text-[#fe7f2d]' />
                            <label>{t("Lieu")} <span className='text-red-600'>*</span></label>
                        </div>
                        <input defaultValue={address.Adresses} type='text' name='lieu' onChange={handleInputChange} placeholder="Ex : Cocody, Abidjan, Côte d'ivoire " className='xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded' />
                        {errors.adresse && <p className='text-red-500'>{errors.adresse}</p>}
                    </div>
                </div>

                <div className='bg-white  s:p-4 xs:p-10 xs:w-full s:w-[260px] sm:w-[340px]  rounded-md border-b-8  shadow flex flex-col space-y-3 '>
                    {/* caractéristique de la chambre */}
                    <p className='text-lg font-semibold'>{t("Dans votre appartement ou chambre")} </p>
                    <div className='grid s:grid-cols-2 sm:grid-cols-3 xs:grid-cols-3 gap-y-8'>
                        {/* piscine */}
                        <div className='flex flex-col space-y-2 '>
                            <div className='flex flex-row items-center space-x-2'>
                                <MdOutlinePool className='text-xl text-[#fe7f2d]' />
                                <label>{t("Piscine")} <span className='text-red-600'>*</span></label>
                            </div>
                            <div className='flex flex-row items-center space-x-2'>
                                <input onChange={handleInputChange} type='radio' name='piscine' value="1" checked />
                                <label>{t("Oui")}</label>
                            </div>
                            <div className='flex flex-row items-center space-x-2'>
                                <input onChange={handleInputChange} type='radio' name='piscine' value="0" />
                                <label>{t("Non")}</label>
                            </div>
                            {errors.piscine && <p className='text-red-500'>{errors.piscine}</p>}
                        </div>
                        {/* Wifi  */}
                        <div className='flex flex-col space-y-2 '>
                            <div className='flex flex-row items-center space-x-2'>
                                <MdOutlineWifi className='text-xl text-[#fe7f2d]' />
                                <label>{t("Wifi")} <span className='text-red-600'>*</span> </label>
                            </div>
                            <div className='flex flex-row items-center space-x-2'>
                                <input onChange={handleInputChange} type='radio' name='wifi' value="1" checked />
                                <label>{t("Oui")}</label>
                            </div>
                            <div className='flex flex-row items-center space-x-2'>
                                <input onChange={handleInputChange} type='radio' name='wifi' value="0" />
                                <label>{t("Non")}</label>
                            </div>
                            {errors.wifi && <p className='text-red-500'>{errors.wifi}</p>}
                        </div>
                        {/* TV */}
                        <div className='flex flex-col space-y-2 '>
                            <div className='flex flex-row items-center space-x-2'>
                                <GiCctvCamera className='text-xl text-[#fe7f2d]' />
                                <label>Cameras <span className='text-red-600'>*</span></label>
                            </div>
                            <div className='flex flex-row items-center space-x-2'>
                                <input onChange={handleInputChange} type='radio' name='camera' value="1" checked />
                                <label>{t("Oui")}</label>
                            </div>
                            <div className='flex flex-row items-center space-x-2'>
                                <input onChange={handleInputChange} type='radio' name='camera' value="0" />
                                <label>{t("Non")}</label>
                            </div>
                            {errors.camera && <p className='text-red-500'>{errors.camera}</p>}
                        </div>
                        {/* Pétit déjeuner */}
                        <div className='flex flex-col space-y-2 '>
                            <div className='flex flex-row items-center space-x-2'>
                                <MdBalcony className='text-xl text-[#fe7f2d]' />
                                <label>{t("Balcon")} <span className='text-red-600'>*</span></label>
                            </div>
                            <div className='flex flex-row items-center space-x-2'>
                                <input onChange={handleInputChange} type='radio' name='balcon' value="1" checked />
                                <label>{t("Oui")}</label>
                            </div>
                            <div className='flex flex-row items-center space-x-2'>
                                <input onChange={handleInputChange} type='radio' name='balcon' value="0" />
                                <label>{t("Non")}</label>
                            </div>
                            {errors.balcon && <p className='text-red-500'>{errors.balcon}</p>}
                        </div>
                        {/* Micro onde */}
                        <div className='flex flex-col space-y-2 '>
                            <div className='flex flex-row items-center space-x-2'>
                                <MdElevator className='text-xl text-[#fe7f2d]' />
                                <label>{t("Ascenseur")} <span className='text-red-600'>*</span></label>
                            </div>
                            <div className='flex flex-row items-center space-x-2'>
                                <input onChange={handleInputChange} type='radio' name='ascenseur' value="1" checked />
                                <label>{t("Oui")}</label>
                            </div>
                            <div className='flex flex-row items-center space-x-2'>
                                <input onChange={handleInputChange} type='radio' name='ascenseur' value="0" />
                                <label>{t("Non")}</label>
                            </div>
                            {errors.ascenseur && <p className='text-red-500'>{errors.ascenseur}</p>}
                        </div>
                        {/* Baignoire */}
                        <div className='flex flex-col space-y-2 '>
                            <div className='flex flex-row items-center space-x-2'>
                                <FaBellConcierge className='text-xl text-[#fe7f2d]' />
                                <label>Conciegre <span className='text-red-600'>*</span></label>
                            </div>
                            <div className='flex flex-row items-center space-x-2'>
                                <input onChange={handleInputChange} type='radio' name='concierge' value="1" checked />
                                <label>{t("Oui")}</label>
                            </div>
                            <div className='flex flex-row items-center space-x-2'>
                                <input onChange={handleInputChange} type='radio' name='concierge' value="0" />
                                <label>{t("Non")}</label>
                            </div>
                            {errors.concierge && <p className='text-red-500'>{errors.concierge}</p>}
                        </div>
                        {/* Ustensile de cuisine */}
                        <div className='flex flex-col space-y-2 '>
                            <div className='flex flex-row items-center space-x-2'>
                                <RiParkingBoxFill className='text-xl text-[#fe7f2d]' />
                                <label>Parking <span className='text-red-600'>*</span></label>
                            </div>
                            <div className='flex flex-row items-center space-x-2'>
                                <input onChange={handleInputChange} type='radio' name='parking' value="1" checked />
                                <label>{t("Oui")}</label>
                            </div>
                            <div className='flex flex-row items-center space-x-2'>
                                <input onChange={handleInputChange} type='radio' name='parking' value="0" />
                                <label>{t("Non")}</label>
                            </div>
                            {errors.parking && <p className='text-red-500'>{errors.parking}</p>}
                        </div>
                        {/* frigo */}
                        <div className='flex flex-col space-y-2 '>
                            <div className='flex flex-row items-center space-x-2'>
                                <MdOutlineSevereCold className='text-xl text-[#fe7f2d]' />
                                <label>{t("Climatiseur")} <span className='text-red-600'>*</span></label>
                            </div>
                            <div className='flex flex-row items-center space-x-2'>
                                <input onChange={handleInputChange} type='radio' name='climatiseur' value="1" checked />
                                <label>{t("Oui")}</label>
                            </div>
                            <div className='flex flex-row items-center space-x-2'>
                                <input onChange={handleInputChange} type='radio' name='climatiseur' value="0" />
                                <label>{t("Non")}</label>
                            </div>
                            {errors.clim && <p className='text-red-500'>{errors.clim}</p>}
                        </div>
                         {/* frigo */}
                         <div className='flex flex-col space-y-2 '>
                            <div className='flex flex-row items-center space-x-2'>
                                <LuArmchair className='text-xl text-[#fe7f2d]' />
                                <label>{t("Meublé")} <span className='text-red-600'>*</span></label>
                            </div>
                            <div className='flex flex-row items-center space-x-2'>
                                <input onChange={handleInputChange} type='radio' name='meuble' value="1" checked />
                                <label>{t("Oui")}</label>
                            </div>
                            <div className='flex flex-row items-center space-x-2'>
                                <input onChange={handleInputChange} type='radio' name='meuble' value="0" />
                                <label>{t("Non")}</label>
                            </div>
                            {errors.meuble && <p className='text-red-500'>{errors.meuble}</p>}
                        </div>
                    </div>
                </div>

                <div className='bg-white s:p-4 xs:p-10 xs:w-full s:w-[260px] sm:w-[340px] rounded-md border-b-8  shadow flex flex-col space-y-3 '>
                    {/* nombre de personne */}
                    <div className='flex flex-col space-y-3'>
                        <div className='flex flex-row items-center space-x-2'>
                            <CiCalendarDate className=' text-[#fe7f2d]' />
                            <label>{t("Date de disponibilité")} <span className='text-red-600'>*</span></label>
                        </div>
                        <input name='date' onChange={handleInputChange} type='date' className='xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded'  />
                        {errors.date && <p className='text-red-500'>{errors.date}</p>}
                    </div>
                    {/* équipement */}
                    <div className='flex flex-col space-y-3'>
                        <div className='flex flex-row items-center space-x-2'>
                            <MdOutlineRoomPreferences className=' text-[#fe7f2d]' />
                            <label>{t("Équipements")} <span className='text-red-600'>*</span></label>
                        </div>
                        <input type='text' onChange={handleInputChange} name='note' placeholder='Ex : Bureau, Machine à café, Minibar, Fer à rapasser, Netflix, Canal+ ' className='xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded'/>
                        {errors.note && <p className='text-red-500'>{errors.note}</p>}
                    </div>
                    {/* Tarif */}
                    <div className='flex flex-col space-y-3'>
                        <div className='flex flex-row items-center space-x-2'>
                            <GiMoneyStack className='text-xl text-[#fe7f2d]' />
                            <label>{t("Tarif")} <span className='text-red-600'>*</span></label>
                        </div>
                        <input id="prix"  onChange={handleInputChange} type='number' name='prix'  placeholder='Ex : 70000 ' min={1} className='xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded'/>
                        {errors.prix && <p className='text-red-500'>{errors.prix}</p>}
                        <small>{t("Le tarif doit être par nuitée")}</small>
                    </div>
                    {/* Description */}
                    <div className='flex flex-col space-y-3'>
                        <div className='flex flex-row items-center space-x-2'>
                            <AiOutlineEdit className='text-xl text-[#fe7f2d]' />
                            <label>{t("Description de la chambre")} <span className='text-red-600'>*</span></label>
                        </div>
                        <textarea onChange={handleInputChange} name="msg" className='xs:w-[500px] s:w-[230px] sm:w-[300px] rounded p-2 h-[200px]'></textarea>
                        {errors.desc && <p className='text-red-500'>{errors.desc}</p>}
                    </div>
                </div>

                <div className='bg-white s:p-4 xs:p-10 xs:w-full s:w-[260px] sm:w-[340px] rounded-md border-b-8  shadow flex flex-col space-y-3 '>
                    {/* date debut */}
                    <div className='flex flex-col space-y-3'>
                        <div className='flex flex-row items-center space-x-2'>
                            <CiCalendarDate className=' text-[#fe7f2d]' />
                            <label>{t("Date de debut affichage")} <span className='text-red-600'>*</span></label>
                        </div>
                        <input id="date_debut"  name='date_debut' onChange={handleInputChange} type='date' 
                            className='xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded'
                            min={today}
                          />
                        {errors.date_debut && <p className='text-red-500'>{errors.date_debut}</p>}
                    </div>

                    {/* date fin */}
                    <div className='flex flex-col space-y-3'>
                        <div className='flex flex-row items-center space-x-2'>
                            <CiCalendarDate className=' text-[#fe7f2d]' />
                            <label>{t("Date de fin affichage")} <span className='text-red-600'>*</span></label>
                        </div>
                        <input id="date_fin"  name='date_fin' onChange={handleInputChange} type='date'
                                  className='xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded'
                                  min={today}
                               />
                        {errors.date_fin && <p className='text-red-500'>{errors.date_fin}</p>}
                    </div>
                    {totalPaid !== 0 && !isNaN(totalPaid) &&(
                    
                            <div className='flex flex-col items-center mx-2 space-y-3 text-center '>
                                <div className='flex flex-row items-center space-x-2 bg-[#1F2937] h-10 rounded'>
                                    <GiMoneyStack className='text-xl text-white' />
                                    <label className='text-white w-[250px] text-bold'>{t("Montant total")}: {totalPaid} F CFA</label>                                    
                                </div>
                            </div>
                    )
                    }
                </div>

                {(totalPaid !== 0 && !isNaN(totalPaid)) ?
                    <button className='bg-[#FCCA46] w-[250px] h-10 rounded
                     text-white'>{t("Procéder au paiement")}</button>
                
                    :
                    <button className='bg-[#FCCA46] w-[150px] h-14 rounded
                     text-white'>{totalPaid === 0 ? t("Ajouter gratuitement") : t("Ajouter")}</button>
                }

            </form>

            {
                open && (
                <div className="fixed inset-0 flex items-center justify-center bg-gray-500 bg-opacity-50 z-50">
                    <div className="bg-white rounded-lg p-6 w-full max-w-3xl relative max-h-screen overflow-y-auto">
                        {/* Bouton de fermeture à l'intérieur du modal */}
                        <button
                        onClick={() => setOpen(false)}
                        className="absolute top-3 right-3 text-red-500 text-2xl"
                    >
                        &times;
                    </button>
                        <Create item="Rechargement de la carte AZ"  options={options} onSuccess={submitForm} ></Create>
                    </div>
                </div>
            )
            }

            </div>
        </div>
              </>
          )}
    </div>
  )
}

export default AjoutHebergement